import React, { Component } from 'react';
import AdminFunctions from '../admin/AdminFunctions';
import { Container, Row, Col, Input, Button, Table, Spinner, UncontrolledTooltip } from 'reactstrap';
import { FaSort } from 'react-icons/fa'
import '../layout/site.css';

export class Accounts extends Component {
    static displayName = Accounts.name;

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    async componentDidMount() {
        document.getElementsByTagName('html')[0].className = "";
    }

    render() {
        //Put in logic here! 

        return (
            <div>
            </div>
        )
    }
}